import { useEffect } from 'react';
import { getFullUrl } from 'hubspot-url-utils';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { getIsLocalDevelopment } from 'marketplace-ui-common/utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
export function ThirdPartyAuthState() {
  const isLocalDevelopment = getIsLocalDevelopment();
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const state = urlParams.get('state');
    const targetOrigin = getFullUrl(isLocalDevelopment ? 'local' : 'app');
    const message = {
      type: 'THIRD_PARTY_AUTH_STATE',
      state
    };
    if (window.opener) {
      // post message to the opener window
      window.opener.postMessage(message, targetOrigin);
    }
  }, [isLocalDevelopment]);
  return /*#__PURE__*/_jsx(LoadingSpinner, {});
}